import CommentList from './comment_list'
import connect from './connect'

export default connect(CommentList)
